import React, { useEffect, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import { updateObject } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import { getTimestampDifference } from "../../shared_components/utils"

export default function ConfidentialityModal({ config, reloadConfig }) {
  const [showModal, setShowModal] = useState(false)
  const [siteMessage, setSiteMessage] = useState(undefined)
  const { user = {}, confidentiality_statement = "", has_external_read_only = false } = config

  useEffect(() => {
    if (confidentiality_statement) {
      setSiteMessage(confidentiality_statement)
      if (user?.last_login) {
        const lastLogin = user?.last_login
        const agreeDate = user?.date_confidentiality_last_acknowledged
        const days = getTimestampDifference(lastLogin, agreeDate, false)?.days
        if ((!agreeDate || days < 0) && has_external_read_only) {
          // Get updated agreement date everytime user logs in
          setShowModal(true)
        }
      }
    }
  }, [user, confidentiality_statement, has_external_read_only])

  const [warning, setWarning] = useState(false)
  const closeModal = () => {
    setWarning(false)
    user.id &&
      updateObject(`/users/list/${user.id}/update_confidentiality_agreement_date/`, {})
        .then((_) => {
          reloadConfig()
          setShowModal(false)
          setWarning(false)
        })
        .catch((err) => {
          console.error(err)
          logToServer(err)
          setWarning(true)
          setTimeout(() => {
            setShowModal(false)
            setWarning(false)
          }, 2000)
        })
  }

  return (
    <>
      {siteMessage && (
        <>
          <Button
            variant={"outline-primary"}
            size={"sm"}
            style={{ display: "inline-flex", justifyContent: "center", alignItems: "center", height: "31px" }}
            title={"Confidentiality Statement"}
            onClick={() => setShowModal(true)}
          >
            <span className={"fa fa-regular fa-shield"} />
          </Button>

          {showModal && (
            <Modal
              show={showModal}
              onHide={closeModal}
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Confidentiality Statement</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>{siteMessage}</div>
              </Modal.Body>
              <Modal.Footer>
                <div>
                  {warning && (
                    <span className={"error-message"}>
                      <FormattedMessage id={"general.server.error"} description={"General server error"} />
                    </span>
                  )}
                </div>
                <Button variant={"primary"} onClick={closeModal} style={{ marginLeft: "auto" }}>
                  Acknowledge
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </>
      )}
    </>
  )
}
